import { render, staticRenderFns } from "./SpecimensWithPosturas.vue?vue&type=template&id=8f9faa32&scoped=true"
import script from "./SpecimensWithPosturas.vue?vue&type=script&lang=js"
export * from "./SpecimensWithPosturas.vue?vue&type=script&lang=js"
import style0 from "./SpecimensWithPosturas.vue?vue&type=style&index=0&id=8f9faa32&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8f9faa32",
  null
  
)

export default component.exports